import styled from "styled-components";
import colors from "styles/colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
  height: 100%;
  gap: 28px;
  font-size: 60px;
  color: blue;
  box-sizing: border-box;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
  border-radius: 8px 0px;
  box-sizing: border-box;
  background: ${colors.white};
`;
